/* FL: siatka produktow komplementarnych (blok fl_complementary_grid w main-product).
   Fetch rekomendacji jak ProductRecommendations motywu, ale ekstrakcja po data-block-id,
   zeby nie kolidowac z innymi elementami rekomendacji w tej samej sekcji.
   Gdy brak rekomendacji — caly blok (.product-info__block) jest chowany. */
class FLComplementaryGrid extends HTMLElement {
  connectedCallback() {
    if (window.initLazyScript) {
      window.initLazyScript(this, this.init.bind(this), 500);
    } else {
      this.init();
    }
  }

  hideBlock() {
    const wrapper = this.closest('.product-info__block') || this;
    wrapper.setAttribute('hidden', '');
  }

  async init() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';

    /* Tryb kolekcji: karty wyrenderowane server-side (brak data-url) — bez fetchu.
       Gdy wykluczenia odfiltrowaly wszystko, chowamy caly blok. */
    if (!this.dataset.url) {
      if (!this.querySelector('.fl-cg-card')) this.hideBlock();
      return;
    }

    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) throw new Error(response.status);

      const tmpl = document.createElement('template');
      tmpl.innerHTML = await response.text();

      const el = tmpl.content.querySelector(`fl-complementary-grid[data-block-id="${this.dataset.blockId}"]`);
      if (el && el.hasChildNodes() && el.querySelector('.fl-cg-card')) {
        this.innerHTML = el.innerHTML;
      } else {
        this.hideBlock();
      }
    } catch (error) {
      this.hideBlock();
      console.log(error); // eslint-disable-line
    }
  }
}

customElements.define('fl-complementary-grid', FLComplementaryGrid);

document.addEventListener('click', (e) => {
  if (!e.target.closest) return;

  /* Stepper ilosci: minus/plus przy input[name="quantity"] w kafelku */
  const stepBtn = e.target.closest('fl-complementary-grid .fl-cg-qty-btn');
  if (stepBtn) {
    const input = stepBtn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const step = parseInt(stepBtn.dataset.flCgStep, 10) || 1;
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 999;
    const next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.min(Math.max(next, min), max);
    return;
  }

  /* "Rozwiń": pokaz pozostale wiersze i usun przycisk */
  const expandBtn = e.target.closest('fl-complementary-grid .fl-cg-expand');
  if (expandBtn) {
    const host = expandBtn.closest('fl-complementary-grid');
    const grid = host && host.querySelector('.fl-cg-grid');
    if (grid) grid.classList.remove('fl-cg-grid--collapsed');
    expandBtn.remove();
  }
});
